const menus = [
    {
        id: 1,
        tomenu: "#about",
        namemenu: "Sobre el libro"
    },
    {
        id: 2,
        tomenu: "#chapters",
        namemenu: "capítulos"
    },
    {
        id: 3,
        tomenu: "#author",
        namemenu: "author"
    },
    {
        id: 4,
        tomenu: "#contact",
        namemenu: "Contact"
    }
    /*{
        id: 5,
        tomenu: "#contact",
        namemenu: "Contact"
    },*/
];



export default menus ;